// w19.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W19 = () => {
  return <WW config={pageConfigs.w19} />;
};

export default W19;
